import React, {useState, useEffect} from "react";

import axios from "axios";
import {Modal, Button} from "react-bootstrap";
import {TextField, InputLabel} from "@material-ui/core";
import {useDispatch} from "react-redux";

import {actions} from "app/hoc/Snackbar/snackbarRedux";
import {actions as ticketActions} from "app/modules/Tickets/_redux/ticketRedux";

const {setSnackbar} = actions;

const messageCodes = {
    1000: {
        variant: "success",
        label: "Müraciətiniz qəbul edildi"
    },
    1001: {
        variant: "error",
        label: "Davam edən sorğunuz var"
    }
}

export default function InterimPaymentModal({show, onHide}) {
    const [amount, setAmount] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ticketActions.setCanFocusScanInput(false))

        return () => {
            dispatch(ticketActions.setCanFocusScanInput(true))
        }
    }, [])

    function handleChange(e) {
        const {target: {value}} = e;
        const regex = new RegExp(/^[0-9.]+$/g);
        if(regex.test(value)) {
            setAmount(value);
        } else if(value === "") {
            setAmount(value)
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        const parsedAmount = parseFloat(amount)
        try {
            const res = await axios({
                url: "agent/interimpayment",
                method: "POST",
                params: {
                    amount: parsedAmount
                }
            });
            setIsLoading(false);
            dispatch(setSnackbar({
                variant: "error",
                message: messageCodes[res.data?.messageCode] ?? "Müraciət uğursuz oldu"
            }));
            onHide(false);
        } catch (err) {
            console.log(err)
            setIsLoading(false);
        }
    }

    return (
        <Modal centered show={show} onHide={onHide}>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <InputLabel>Məbləğ:</InputLabel>
                    <TextField
                        name="amount"
                        value={amount}
                        onChange={handleChange}
                        className="w-100"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={isLoading} type="submit">Göndər</Button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}